import isEqual from 'lodash/isEqual';

// front/docs/SPA_ARCHITECTURE_AUDIT.md finding RD3: every list-reducer
// SUCCESS handler assigned the raw API response array unconditionally, so a
// re-fetch that returned byte-identical data still produced a brand-new
// array reference — any downstream consumer relying on reference equality
// (memoized selectors/components) re-rendered anyway.
const preserveArrayReference = (previous, next) => (isEqual(previous, next) ? previous : next);

export default preserveArrayReference;
